import React, { createContext, useContext } from 'react';

const StateCntxt = createContext();
const DispatchCntxt = createContext();

export const useTreeCheckState = () => useContext(StateCntxt);
export const useTreeCheckDispatch = () => useContext(DispatchCntxt);

export const TreeCheckProvider = ({ children, state, dispatch }) => {
  return (
    <StateCntxt.Provider value={state}>
      <DispatchCntxt.Provider value={dispatch}>
        {children}
      </DispatchCntxt.Provider>
    </StateCntxt.Provider>
  );
};
